"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Types = void 0;
var react_1 = __importDefault(require("react"));
var D = __importStar(require("../../../data"));
var view_1 = __importDefault(require("./view"));
var form_1 = __importDefault(require("./form"));
var Types = __importStar(require("./type"));
exports.Types = Types;
var Utils = __importStar(require("./utils"));
var Address = function (_a) {
    var countryList = _a.countryList, data = _a.data, update = _a.update, notFoundMessage = _a.notFoundMessage, showMap = _a.showMap;
    return (react_1["default"].createElement(D.Detail, { data: __assign({ isSet: Utils.getInitialIsSet(data) }, data), ViewUI: function (props) { return (react_1["default"].createElement(view_1["default"], __assign({ notFoundMessage: notFoundMessage, showMap: showMap }, props))); }, FormUI: function (props) { return react_1["default"].createElement(form_1["default"], __assign({ countryList: countryList }, props)); }, promise: update }));
};
var AddressLoader = function (props) { return (react_1["default"].createElement(D.Load.WithLoader, __assign({ Component: Address }, props))); };
exports["default"] = AddressLoader;
